angular.module('cfn').service('CropPlanningData', [
  '$resource',
  function($resource) {
    this.CropOverview = $resource(
      '/365FarmNet/rest/analyse/cropoverview/overview/:year'
    );

    return this;
  }
]);
